import { render, staticRenderFns } from "./phnews.vue?vue&type=template&id=ca0d6862"
import script from "./phnews.vue?vue&type=script&lang=js"
export * from "./phnews.vue?vue&type=script&lang=js"
import style0 from "./phnews.vue?vue&type=style&index=0&id=ca0d6862&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports